import { BUSINESS_LIMITS } from '../constants/limits';
/**
 * KODUN AMACI (05.09.2026 · K4). Kod amacı dışında GEÇMEZ: sıfırlama kodu giriş
 * açamaz, onay kodu şifre yazdıramaz. SUNUCU İÇİ değerdir — Joi almaz. `login`
 * panel girişinin ikinci adımını da kapsar (panel iddiası ayrı boolean sütunda:
 * o, amacın değil YOLUN özelliği). `step_up` hassas işlem öncesi yeniden
 * doğrulamadır, OTURUM AÇMAZ; ayrı amaç şart çünkü K5 kodla girişi şifreli
 * hesaba kapattı ama kırmızı çizgi 3 orada da geçerlidir.
 */
export const OTP_PURPOSES = ['login', 'registration', 'password_reset', 'step_up'];
/**
 * KOD TAMAM MI (B-22). Uzunluk tek başına yetmez: "info@e" altı karakterdir ve
 * veri hakları düğmesini açıyordu. Sunucu şeması (`/^\d+$/` + uzunluk) ile aynı
 * kural, web ve mobil talep düğmesi buradan okur.
 */
export function isCompleteOtpCode(value) {
    return value.length === BUSINESS_LIMITS.otpCodeLength && /^\d+$/.test(value);
}
/**
 * KOD ALANINA GİREN METİN (B-22, tech-lead). Rakam dışı her karakter atılır,
 * kırpma ANCAK ONDAN SONRA yapılır. Sıra yüktür: alanın `maxLength` taşıması ya
 * da önce kırpıp sonra süzmek "Kodunuz 123456" yapıştırmasını süzgeçten ÖNCE
 * "Kodunu"ya keser ve kod hiç girilemez. Web `OtpCodeField` ve mobil
 * `CodeField` buradan okur; ikisi aynı kuralı ayrı ayrı yazıyordu.
 */
export function extractOtpDigits(value, length = BUSINESS_LIMITS.otpCodeLength) {
    return value.replace(/\D/g, '').slice(0, length);
}
/**
 * ALANIN YENİ DEĞERİ (sıra 115b). Kısmi değer varken yapıştırılan metin eskinin
 * ARDINA ekleniyordu: "12" + "Kodunuz 123456" → "121234". Eklenen parça TAM BİR
 * KOD taşıyorsa (yapıştırma) alan onunla BAŞTAN dolar; kısa ekleme (tuş, eksik
 * haneleri tamamlayan otomatik doldurma) eskisine eklenir. Eklenen parça eski ve
 * yeni metnin ortak başı ve sonu atılarak bulunur.
 */
export function nextOtpCode(previous, raw, length = BUSINESS_LIMITS.otpCodeLength) {
    let head = 0;
    while (head < previous.length && head < raw.length && previous[head] === raw[head])
        head += 1;
    let tail = 0;
    while (tail < previous.length - head &&
        tail < raw.length - head &&
        previous[previous.length - 1 - tail] === raw[raw.length - 1 - tail]) {
        tail += 1;
    }
    const insertedDigits = raw.slice(head, raw.length - tail).replace(/\D/g, '');
    if (insertedDigits.length >= length)
        return insertedDigits.slice(0, length);
    return extractOtpDigits(raw, length);
}
//# sourceMappingURL=otp.js.map